import React from 'react';
import NumberFormat from 'react-number-format';

import Input from '@zego/components/atoms/Input';

const currencyCodeToSymbol = {
  GBP: '£',
  EUR: '€',
};

type CurrencyCodeOptions = 'GBP' | 'EUR';

interface CurrencyInputProps {
  currencyCode: CurrencyCodeOptions;
  decimals?: number;
  onChange?: () => void;
}

const CurrencyInput = ({
  currencyCode,
  decimals = 2,
  onChange,
  ...inputProps
}: CurrencyInputProps): JSX.Element => {
  const symbol = currencyCodeToSymbol[currencyCode];
  return (
    <NumberFormat
      thousandSeparator={true}
      prefix={symbol}
      allowNegative={false}
      decimalScale={decimals}
      customInput={Input}
      onValueChange={onChange}
      {...inputProps}
    />
  );
};

export default CurrencyInput;
